module.exports = __webpack_public_path__ + "img/edit.523c0332.svg";